import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { classNames } from '../../../../../../utils/classname';
import { ChildrenPropType } from '../../../../../foundation/types/component';
import './Line.css';
var defaultProps = {
  children: null,
  content: null,
  className: ''
};
export default function Line(_ref) {
  var children = _ref.children,
    content = _ref.content,
    className = _ref.className;
  var finalContent = content || children;
  var finalClassName = classNames(_defineProperty({
    line: true
  }, className, className));
  return /*#__PURE__*/React.createElement("div", {
    className: finalClassName
  }, finalContent);
}
Line.defaultProps = defaultProps;